import type {
  TGetListaDeImobiliariasCorretoresParams,
  TGetListaDeImobiliariasCorretoresResponse,
  TImobiliariaCorretor,
} from '@/features/proposta/shared/types/imobiliarias.types'
import { HttpService } from '@/infra/http'

export class GetListarImobiliariasCorretoresService<TImobiliaria = TImobiliariaCorretor> extends HttpService {
  async execute(params?: TGetListaDeImobiliariasCorretoresParams) {
    return this.http.get<TGetListaDeImobiliariasCorretoresResponse<TImobiliaria>>('/api/v2/ImobiliariaCorretor/lista', {
      params,
    })
  }
}
